"use client";

import Modal from "@/components/ui/modal";
import GrowWithUsForm from "./grow-with-us-form";

type TGrowWithUsModalProps = {
	isOpen: boolean;
	onClose: () => void;
	message?: string;
};

const GrowWithUsModal = ({ isOpen, onClose, message }: TGrowWithUsModalProps) => {
	return (
		<Modal title="Grow with us" isOpen={isOpen} onClose={onClose} className="max-w-md px-8 py-6">
			<GrowWithUsForm message={message} />
		</Modal>
	);
};

export default GrowWithUsModal;
